import { widgetLoader } from '../../widgetLoader'
import { reinitialize as reinitializeVendorPackages } from '@/vendor/packages'

const displayNotifications = (notifier: any, messages: object) => {

  if (!messages) return

  try {
    for (const key of Object.keys(messages)) {
      if (messages[key].length) {
        for (const msg of messages[key]) {
          notifier.notify(msg, key)
        }
      }
    }
  } catch (e) {
    console.log('Error while processing notifications: a084621b-cba4-4371-bbe9-ab39b77a56ed')
    console.log(e)
  }

}

const installEventHandlers = (notifier: any) => {

  $(document).on('vue3.widgets-reparse', (event, source) => {

    widgetLoader.parse().then(() => {
      reinitializeVendorPackages()
    })

  })

  $(document).on('vue3.notify', (event, messages) => {

    displayNotifications(notifier, messages)

  })

  /*
   * legacy handlers, will be removed in the next hcl release
   */
  $(document).on('hcl.hcl-widgets-reparse', (event, source) => {

    widgetLoader.parse().then(() => {
      reinitializeVendorPackages()
    })

  })

  $(document).on('hcl.hcl-notify', (event, messages) => {

    displayNotifications(notifier, messages)

  })

}

const vue3bootstrap = (notifier: any) => {

  if (window.Esearcher && !window.Esearcher.vue3) {

    installEventHandlers(notifier)

    window.Esearcher.vue3 = { 'status': 'initialization-complete' }

  }

}

export {
  vue3bootstrap
}
